// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1RaftedCheckHealth
 */
export interface V1RaftedCheckHealth {
  /**
   *
   * @type {number}
   * @memberof V1RaftedCheckHealth
   */
  consecutiveFailures?: number;
  /**
   *
   * @type {string}
   * @memberof V1RaftedCheckHealth
   */
  firstFailureTime?: string;
  /**
   *
   * @type {string}
   * @memberof V1RaftedCheckHealth
   */
  lastFailureTime?: string;
  /**
   *
   * @type {string}
   * @memberof V1RaftedCheckHealth
   */
  lastSuccessTime?: string;
}

/**
 * Check if a given object implements the V1RaftedCheckHealth interface.
 */
export function instanceOfV1RaftedCheckHealth(
  value: object,
): value is V1RaftedCheckHealth {
  return true;
}

export function V1RaftedCheckHealthFromJSON(json: any): V1RaftedCheckHealth {
  return V1RaftedCheckHealthFromJSONTyped(json, false);
}

export function V1RaftedCheckHealthFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1RaftedCheckHealth {
  if (json == null) {
    return json;
  }
  return {
    consecutiveFailures:
      json['consecutiveFailures'] == null
        ? undefined
        : json['consecutiveFailures'],
    firstFailureTime:
      json['firstFailureTime'] == null ? undefined : json['firstFailureTime'],
    lastFailureTime:
      json['lastFailureTime'] == null ? undefined : json['lastFailureTime'],
    lastSuccessTime:
      json['lastSuccessTime'] == null ? undefined : json['lastSuccessTime'],
  };
}

export function V1RaftedCheckHealthToJSON(json: any): V1RaftedCheckHealth {
  return V1RaftedCheckHealthToJSONTyped(json, false);
}

export function V1RaftedCheckHealthToJSONTyped(
  value?: V1RaftedCheckHealth | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    consecutiveFailures: value['consecutiveFailures'],
    firstFailureTime: value['firstFailureTime'],
    lastFailureTime: value['lastFailureTime'],
    lastSuccessTime: value['lastSuccessTime'],
  };
}
